import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../utils';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';

const DeletePartnerCampaignRequestSchema = z
  .object({
    campaignId: z.union([z.string(), z.number()]),
    brandId: z.string(),
  })
  .describe('DeletePartnerCampaignRequestSchema');

export type DeletePartnerCampaignRequest = z.infer<typeof DeletePartnerCampaignRequestSchema>;

const DeletePartnerCampaignResponseSchema = createApiResponseSchema(z.unknown());

export type DeletePartnerCampaignResponse = z.infer<typeof DeletePartnerCampaignResponseSchema>;

/** DELETE `/v1/partner/campaigns/{campaignId}` — 캠페인 삭제 */
export const deletePartnerCampaign = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(DeletePartnerCampaignRequestSchema),
    async ({ campaignId, brandId }: DeletePartnerCampaignRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.delete<DeletePartnerCampaignResponse>(
          partnerApiPath.deleteCampaign(campaignId),
          { brandId },
        ),
      ),
    validateApiResponse(DeletePartnerCampaignResponseSchema),
  ),
);
